export default "__VITE_ASSET__BNdqC7Jj__"